module.exports = __webpack_public_path__ + "assets/img/5.5f25ca60.png";